import React, { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Clickable div element should only be used when the standard button can't be used
 * @param children
 * @param onClick
 * @param onKeyDown
 * @param other
 * @constructor
 */
export const ClickableDiv = /*#__PURE__*/React.forwardRef(({
  children,
  onClick,
  onKeyDown,
  ...other
}, ref) => {
  const handleKeyDown = useCallback(event => {
    // Check to see if space or enter were pressed
    // "Spacebar" for IE11 support
    if (event.key === ' ' || event.key === 'Enter' || event.key === 'Spacebar') {
      // Prevent the default action to stop scrolling when space is pressed
      event.preventDefault();
      onClick(event);
    }
    onKeyDown?.(event);
  }, [onClick, onKeyDown]);
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    role: "button",
    tabIndex: 0,
    style: {
      cursor: 'pointer'
    },
    onClick: onClick,
    onKeyDown: handleKeyDown,
    ...other,
    children: children
  });
});